<script lang="ts" setup>

const props = defineProps({
    loaderText: { type: String, default: '', required: false },
    type: { type: String,  default: 'flip', required: false }
});

</script>
<template>
    <div :class="['loading-overlay', type]">
        <div class="loader"></div>
        <div v-if="loaderText!=''" class="loader-title">{{ loaderText }}</div>
    </div>
</template>
<style lang="scss">
    @use './style.scss';
</style>